// generation_status reflects the requester's most recent PromptToLessonJob
// of any kind (microlessons and AI videos share the table), so it can be
// shadowed by a later non-microreel generation.
export enum MicroreelsGenerationStatus {
  NotStarted = 0,
  InProgress = 1,
  Completed = 2,
  Failed = 3,
}

export interface MicroreelsGenerationStatusResult {
  status?: number;
  microreelsId?: string;
}

export interface MicroreelCourseSettings {
  is_public: boolean;
  subjectId: string | null;
}

export interface MicroreelGenerationModel extends MicroreelCourseSettings {
  prompt: string;
  generateAiImages?: boolean;
  generateAiVideos?: boolean;
  slideToArtifactRatio?: number;
  chunkDuration: number;
  numberOfBranches?: number;
  addAssessment: boolean;
  passingScoreNumber?: number;
  mandatoryMicroreelIndexes?: number[];
  addAckNode: boolean;
  language: string;
  dialect: string;
  gender: string;
  name: string;
  backgroundAudio?: string;
  backgroundAudioFileId?: string;
  projectId?: string;
}

// generate_from_video keeps the original audio, so there is no voice,
// dialect, music or visuals configuration; passingScore is the percentage,
// like in generate_from_slide.
export interface MicroreelVideoGenerationModel extends MicroreelCourseSettings {
  libraryMediaFileId: string;
  chunkDuration: number;
  numberOfBranches?: number;
  addAssessment: boolean;
  passingScore?: number;
  language?: string;
  name?: string;
  addAckNode: boolean;
  mandatoryMicroreelIndexes?: number[];
  projectId?: string;
}

// Unlike the prompt endpoint (which derives the percentage from
// passingScoreNumber / numberOfBranches), generate_from_slide reads the
// percentage directly from passingScore.
export interface MicroreelSlideGenerationModel extends MicroreelCourseSettings {
  libraryMediaFileId: string;
  addSummariseSlideStep?: boolean;
  // Page numbers to leave out of the generation, as typed by the user
  // (same convention as the AI video wizard's ignoreSlides).
  ignoreSlides?: number[];
  generateAiImages?: boolean;
  generateAiVideos?: boolean;
  slideToArtifactRatio?: number;
  chunkDuration: number;
  numberOfBranches?: number;
  addAssessment: boolean;
  passingScoreNumber?: number;
  passingScore?: number;
  mandatoryMicroreelIndexes?: number[];
  addAckNode: boolean;
  language: string;
  dialect: string;
  gender: string;
  name: string;
  backgroundAudio?: string;
  backgroundAudioFileId?: string;
  projectId?: string;
}
